import styled from 'styled-components'
import { MypageListItemsType, MyPageProps } from 'src/pages/Mypage/index'
import { Noto_body1_b16, Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'
import { NavLink } from 'react-router-dom'
import { Container } from 'src/components/common/Container'
import { Icon } from 'src/assets/svg/Icon'
import { Typography } from 'src/components/common/Typography'
import { SmallDivider } from 'src/components/common/Divider'

const MyPageView = ({ couponManagementListItems, helpCenterListItems }: MyPageProps) => {
  return (
    <S.MyPageContainer $option="flex_column" $row_gap="30px">
      <S.NavItemWrap $option="flex_column" $width="calc(100% - 40px)">
        <S.PrimaryText $fontStyle={Noto_body2_m14} $color="var(--black-50)">
          쿠폰관리
        </S.PrimaryText>
        {couponManagementListItems?.map((ele: MypageListItemsType, index: number) => (
          <S.PageNavLink to={ele?.path} key={index} onClick={ele?.onClickFn}>
            <Typography $fontStyle={Noto_body1_b16} $color="var(--black-90)">
              {ele?.text}
            </Typography>
            <Icon.Arrow size="16" rotate="right" color="var(--black-30)" />
          </S.PageNavLink>
        ))}
      </S.NavItemWrap>
      <SmallDivider />
      <S.NavItemWrap $option="flex_column" $width="calc(100% - 40px)">
        <S.PrimaryText $fontStyle={Noto_body2_m14} $color="var(--black-50)">
          고객센터
        </S.PrimaryText>
        {helpCenterListItems?.map((ele: MypageListItemsType, index: number) => (
          <S.PageNavLink to={ele?.path} key={index} onClick={ele?.onClickFn}>
            <Typography $fontStyle={Noto_body1_b16} $color="var(--black-90)">
              {ele?.text}
            </Typography>
            <Icon.Arrow size="16" rotate="right" color="var(--black-30)" />
          </S.PageNavLink>
        ))}
      </S.NavItemWrap>
    </S.MyPageContainer>
  )
}
export default MyPageView
const S = {
  MyPageContainer: styled(Container)`
    margin: 30px auto;
  `,
  PrimaryText: styled(Typography)`
    margin-bottom: 10px;
  `,
  PageNavLink: styled(NavLink)`
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    align-items: center;
  `,
  NavItemWrap: styled(Container)`
    margin: 0 auto;
  `,
}
